<template>
  <NuxtLayout name="main-view" :headline="$t('dbc-headline-change-tariff')">
    <Card :pt="specialCardPassThrough">
      <template #header
        >{{ $t('dbc-headline-bahn-bonus-change-tariff') }}
      </template>
      <template #content>
        <ul class="m-0 pl-s">
          <li>{{ $t('dbc-text-bahn-bonus-1') }}</li>
          <li>{{ $t('dbc-text-bahn-bonus-2') }}</li>
          <li>{{ $t('dbc-text-bahn-bonus-3') }}</li>
        </ul>
        <div class="flex flex-col gap-2xs">
          <FormKit
            @click="changeTariff"
            type="submit"
            id="submit"
            :label="$t('dbc-text-agree')"
            :disabled="isLoading"
            :loading="isLoading"
            :aria-label="
              !isLoading ? $t('dbc-text-agree') : $t('dbc-text-loading')
            "
          />
          <NuxtLink
            :to="getPagePath['tariff'][locale]"
            :class="buttonSecondary"
          >
            {{ $t('dbc-btn-abort') }}
          </NuxtLink>
        </div>
      </template>
    </Card>
  </NuxtLayout>
</template>

<script setup lang="ts">
const router = useRouter()
const { locale } = useI18n()
import { useCustomerStore } from '../../../../stores/customer'

const customerStore = useCustomerStore()
const { tariffForChange, buesinessParamForChange } = storeToRefs(customerStore)

const isLoading = ref(false)

async function changeTariff() {
  isLoading.value = true
  const response = await fetchChangeTariff({
    tariffId: tariffForChange.value?.id,
    businessParameterValue: buesinessParamForChange.value,
  })
  isLoading.value = false
  if (!response.ok) {
    router.push({
      path: getPagePath['tariff']![locale.value],
      query: { error: 'true' },
    })
  }
  if (response.ok && response.status === 200) {
    customerStore.removeBahnBonusData()
    await customerStore.getContracts()
    router.push({
      path: getPagePath['tariff']![locale.value],
    })
  }
}
</script>
